import React from "react";
import EvidenceTable from "../../Components/evidencetable";

function ExtractiontablePage() {
  return (
    <div>
      {/* <ExtractionTable /> */}
      <EvidenceTable />
    </div>
  );
}

export default ExtractiontablePage;
